import React, { useEffect, useState } from "react";
import SliderAuth from "../../components/SliderAuth/SliderAuth";
import { useDispatch } from "react-redux";
import { images } from "../../config/images";
import { Grid, FormControlLabel, Radio, RadioGroup, FormControl, OutlinedInput, InputAdornment, Checkbox, } from "@mui/material";
import "./Signin.css"
import { Button } from "../../components/Button/button"
import { useNavigate } from "react-router-dom";
import { Button as MaterailUIButoon } from "@mui/material";
import { login, loginWithGoggle } from "../../config/services";
import { setUserDetails } from "./slice/userSlice";
import translations from "../../config/language";
import { signInWithGoogle } from "../../config/firebase";
import { notifyError, notifySuccess } from "../../config/ToastMessage";

const Signin = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [formvalues, setFormvalue] = useState({
        mobileNumber: "",
        password: "",
    });

    const [showPassword, setShowPassword] = useState(false);
    const [isRememberMeChecked, setIsRememberMeChecked] = useState(false);
    const [role, setRole] = useState("admin");
    const [loading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        setFormvalue({ ...formvalues, [e.target.name]: e.target.value });
    };

    const handleRoleChange = (event) => {
        setRole(event.target.value); // Update role state when radio button changes
    };

    const handleTogglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const encryptData = (data) => {
        return btoa(JSON.stringify(data));
    };

    const decryptData = (data) => {
        try {
            return JSON.parse(atob(data));
        } catch {
            return null;
        }
    };

    const handleSubmit = async () => {

        if (!formvalues.mobileNumber) {
            notifyError("Please enter your Mobile Number.");
            return true;
        }

        const mobileRegex = /^[0-9]\d{9}$/;
        if (!mobileRegex.test(formvalues.mobileNumber)) {
            notifyError("Please enter a valid Mobile Number.");
            return true;
        }

        if (!formvalues.password) {
            notifyError("Please enter valid password.");
            return true;
        }

        const params = {
            mobile_number: `91${formvalues.mobileNumber}`,
            password: formvalues.password,
            role: role === "admin" ? 3 : 4, // Set role dynamically (1 for admin, 2 for superadmin)
        }
        try {
            setIsLoading(true);
            const resp = await login(params);
            if (resp.data.success) {
                setIsLoading(false);
                navigate("/");
                notifySuccess(resp.data.message)

                dispatch(
                    setUserDetails({
                        token: resp.data.payload.token,
                        id: resp.data.payload.id,
                        name: resp.data.payload.name,
                        firstName: resp.data.payload.first_name,
                        middleName: resp.data.payload.middle_name,
                        lastName: resp.data.payload.last_name,
                        gender: resp.data.payload.gender,
                        mobileNumber: resp.data.payload.mobile_number,
                        email: resp.data.payload.email,
                        role: resp.data.payload.role,
                        profilePhoto: resp.data.payload.profile_photo,
                        is_mobile_verify: resp.data.payload.is_mobile_verify,
                        is_user_registered: resp.data.payload.is_user_registered,
                        is_active: resp.data.payload.is_active,
                        is_delete: resp.data.is_delete,
                        module_access: resp.data.payload.module_access,
                    })
                );

                // ... existing success code ...

                if (isRememberMeChecked) {
                    const userData = {
                        mobileNumber: formvalues.mobileNumber,
                        password: btoa(formvalues.password),
                        role: resp.data.payload.role,
                        timestamp: new Date().getTime()
                    };
                    localStorage.setItem("userCredentials", encryptData(userData));
                } else {
                    localStorage.removeItem("userCredentials");
                }
            } else {
                notifyError(resp.data.message)
                setIsLoading(false);
            }

        } catch (error) {
            notifyError(error.response.data.message);
            setIsLoading(false);
        }


    }

    const language = process.env.REACT_APP_LANGUAGE;

    // useEffect(() => {
    //     if (sessionStorage.getItem("mobileNumber") && sessionStorage.getItem("password")) {
    //         setFormvalue({
    //             mobileNumber: sessionStorage.getItem("mobileNumber"),
    //             password: atob(sessionStorage.getItem("password"))
    //         });
    //     }
    // }, []);
    useEffect(() => {
        const savedCredentials = localStorage.getItem("userCredentials");
        if (savedCredentials) {
            const userData = decryptData(savedCredentials);
            if (userData && userData.timestamp) {
                // Check if credentials are not older than 30 days
                const thirtyDays = 30 * 24 * 60 * 60 * 1000;
                if (new Date().getTime() - userData.timestamp < thirtyDays) {
                    setFormvalue({
                        mobileNumber: userData.mobileNumber,
                        password: atob(userData.password)
                    });
                    setRole(userData.role === 3 ? "admin" : "superadmin");
                } else {
                    localStorage.removeItem("userCredentials");
                }
            }
        }
    }, []);
    const handleGoogleLogin = async () => {

        try {
            const user = await signInWithGoogle();

            const params = {
                role: role === "admin" ? 3 : 4,
                full_name: user.displayName,
                email: user.email,
                is_google_login: true,
                google_login_id: user.reloadUserInfo.localId
            }
            const resp = await loginWithGoggle(params);

            if (resp.data.success) {
                setIsLoading(false);
                if (resp.data.payload.is_user_registered) {
                    navigate("/");
                    notifySuccess(resp.data.message)
                } else {
                    navigate("/signup");
                    notifyError(resp.data.message)
                }

                dispatch(
                    setUserDetails({
                        token: resp.data.payload.token,
                        id: resp.data.payload.id,
                        name: resp.data.payload.name,
                        firstName: resp.data.payload.first_name,
                        middleName: resp.data.payload.middle_name,
                        lastName: resp.data.payload.last_name,
                        gender: resp.data.payload.gender,
                        mobileNumber: resp.data.payload.mobile_number,
                        email: resp.data.payload.email,
                        role: resp.data.payload.role,
                        profilePhoto: resp.data.payload.profile_photo,
                        is_mobile_verify: resp.data.payload.is_mobile_verify,
                        is_user_registered: resp.data.payload.is_user_registered,
                        is_active: resp.data.payload.is_active,
                        is_delete: resp.data.is_delete,
                        module_access: resp.data.payload.module_access,
                    })
                );
            } else {
                notifyError(resp.data.message)
                setIsLoading(false);
            }
        } catch (error) {
            notifyError(error.response.data.message);
        }
    };

    const handleAppleLogin = async () => {

        // const user = await signInWithApple();

    }


    return (
        <>
            <div></div>
            <Grid container className="main-container">
                <SliderAuth />
                <Grid item xs={12} md={5} lg={4} className="signIn-form-wrap">
                    <div className="">
                        <img src={images.loginLogo} alt="Login" className="signIn-logo" />
                    </div>
                    <h3 className="text-center singIn-title">{translations[language].loginTitle}</h3>
                    {/* Login User Selection */}
                    <p className="singIn-option-p">{translations[language].selectUser}</p>
                    <RadioGroup row value={role} onChange={handleRoleChange} className="login-type" style={{ paddingBottom: "10px" }}>
                        <div className="singIn-option-div">
                            <FormControlLabel value="admin" control={<Radio />} label={translations[language].admin} />
                        </div>
                        <div className="singIn-option-div">
                            <FormControlLabel value="superadmin" control={<Radio />} label={translations[language].superAdmin} />
                        </div>
                    </RadioGroup>

                    {/* Login Fields */}
                    <form
                        onSubmit={(e) => {
                            e.preventDefault(); // Prevent page reload
                            handleSubmit();
                        }}
                    >
                        <div>

                            <FormControl fullWidth sx={{ m: 1 }}>
                                <OutlinedInput
                                    value={formvalues.mobileNumber}
                                    onChange={handleChange}
                                    name="mobileNumber"
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            handleSubmit();
                                        }
                                    }}
                                    inputProps={{ maxLength: 10, pattern: "[0-9]*", inputMode: "numeric" }}
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <img src={images.mobileIcon} alt="mobile-icon" className="input-logo" />
                                        </InputAdornment>}
                                    placeholder={translations[language].mobileNumber}
                                />
                            </FormControl>
                            <FormControl fullWidth sx={{ m: 1 }} variant="outlined">
                                <OutlinedInput
                                    id="outlined-adornment-password"
                                    type={showPassword ? 'text' : 'password'}
                                    value={formvalues.password}
                                    onChange={handleChange}
                                    name="password"
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            handleSubmit();
                                        }
                                    }}
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <img
                                                src={images.viewPassword}
                                                className="input-logo"
                                            >
                                            </img>
                                        </InputAdornment>
                                    }
                                    endAdornment={
                                        <InputAdornment position="start">
                                            <img
                                                src={images.viewIcon}
                                                onClick={handleTogglePasswordVisibility}
                                                className="input-logo"
                                                style={{ cursor: "pointer" }}
                                            >
                                            </img>
                                        </InputAdornment>
                                    }
                                    placeholder={translations[language].password}
                                />
                            </FormControl>
                        </div>
                        <div className="SignIn-keepLogin-wrap">
                            <div className="keepLogin-wrap">
                                <Checkbox
                                    sx={{
                                        color: "#D1D1D1",
                                        borderRadius: "4px",
                                    }}
                                    className="signIncheckBox"
                                    checked={isRememberMeChecked}
                                    onClick={() => setIsRememberMeChecked(!isRememberMeChecked)}
                                />

                                <label for="keepMeLogin" className="keepLogin-label login" onClick={() => setIsRememberMeChecked(!isRememberMeChecked)}>
                                    {translations[language].rememberMe}
                                </label>
                            </div>
                            <div
                                className="forgotPassword-link"
                                style={{ cursor: "pointer" }}
                                onClick={() => navigate("/forgot-password")}
                            >
                                {translations[language].forgotPassword}
                            </div>
                        </div>
                        <div>
                            <Button
                                title={translations[language].loginButton}
                                classname={"custom-button"}
                                type="submit"
                                loading={loading}
                            />
                        </div>
                    </form>

                    {/* Alternative Login Options */}

                    <div className="or-login">
                        <span>{translations[language].orLoginWith}</span>
                    </div>
                    <Grid container spacing={2} style={{ justifyContent: "space-between" }}>
                        <Grid item xs={6} onClick={() => handleGoogleLogin()} >
                            <MaterailUIButoon variant="outlined" startIcon={<img src={images.googleIcon} alt="google-icon" />}>
                                {translations[language].google}
                            </MaterailUIButoon>
                        </Grid>
                        <Grid item xs={6}>
                            <MaterailUIButoon variant="outlined" startIcon={<img src={images.appleIcon} alt="apple-icon" onClick={() => handleAppleLogin()} />}>
                                {translations[language].apple}
                            </MaterailUIButoon>
                        </Grid>
                    </Grid>

                    {/* Sign Up Link */}
                    {role === "admin" && (
                        <>
                            <div className="signup-link">
                                {translations[language].dontHaveAccount}{" "}
                                <a href="/signup" style={{ textDecoration: "none", fontWeight: "700" }}>{translations[language].signUp}</a>
                            </div>
                        </>
                    )}
                </Grid>

            </Grid>

        </>
    )
}

export default Signin;